import React, { useEffect, useRef, useState } from "react";
import styles from "./styles/Main.module.css";
import { useLanguage } from "../LanguageContext";
// import desktopVideo from "../assets/images/black-hole_desktop.mp4";
// import mobileVideo from "../assets/images/black-hole_mobile.gif";

function Main({appMedia}) {
    const [scrolled, setScrolled] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const { t } = useLanguage();
    const videoRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 576);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.setAttribute("muted", "");
            video.setAttribute("autoplay", "");
            video.setAttribute("playsinline", "");
            video.setAttribute("loop", "");
            video.muted = true;
            video.playsInline = true;

            video.play().catch((err) => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.main}>
                {isMobile ? (
                    <img src={appMedia[0].media_mobile} alt="Mobile background" className={styles.backgroundVideo} />
                ) : (
                    <video ref={videoRef} className={styles.backgroundVideo} src={appMedia[0].media_desktop} autoPlay loop muted playsInline />
                )}

                {/* Animated Lines Overlay */}
                <div className={styles.animatedLines}>
                    {[...Array(5)].map((_, index) => (
                        <div key={index} className={styles.lineWrapper} style={{ left: `${20 * (index + 1)}%` }}>
                            <div className={styles.baseLine} />
                            <div className={styles.dropLine} style={{ animationDelay: `${index * 0.5}s` }} />
                        </div>
                    ))}
                </div>

                <div className={styles.overlayContent}>
                    <h1 dangerouslySetInnerHTML={isMobile ? { __html: t("main.titleMobile") } : { __html: t("main.title") }} />
                    <p>{t("main.description")}</p>
                </div>

                <span className={styles.scrollPrompt}>{t("main.scroll")}</span>
            </div>
            <div className={`${styles.bottomText} ${scrolled ? styles.scrolled : ""}`}>COSMOCREDIT</div>
        </div>
    );
}

export default Main;
